import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Construction, ArrowRight } from 'lucide-react';

const StudentPortal = () => {
  return (
    <div className="py-16 md:py-24 min-h-[70vh] flex items-center">
      <div className="container mx-auto px-4 md:px-6 max-w-xl">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="glass-card p-8 md:p-12 text-center"
        >
          <div className="w-20 h-20 rounded-full bg-electric-cyan/20 flex items-center justify-center mx-auto mb-6">
            <Construction className="w-10 h-10 text-electric-cyan" />
          </div>
          
          <h1 className="font-outfit text-3xl font-bold text-white mb-4" data-testid="student-portal-title">
            Student Portal
          </h1>
          
          <p className="text-slate-400 mb-8">
            The Student Portal is coming soon! Once launched, you'll be able to access your course materials, 
            track your progress, and communicate with your instructor.
          </p>

          <div className="bg-surface-navy/50 rounded-xl p-6 mb-8 text-left">
            <h3 className="text-white font-medium mb-3">Coming Features:</h3>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>• Access recorded lessons</li>
              <li>• Practice problems & worksheets</li>
              <li>• Progress tracking</li>
              <li>• Direct messaging with instructor</li>
              <li>• Assignment submissions</li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-secondary">
              Back to Home
            </Link>
            <Link to="/contact" className="btn-primary flex items-center justify-center gap-2">
              Contact Us <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default StudentPortal;
